<template>
  <div class="demo-app">
    <div class="demo-app-main">
      <FullCalendar class="demo-app-calendar" :options="calendarOptions">
        <template v-slot:eventContent="arg">
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>

    <!-- hide for now -->
    <div class="demo-app-sidebar" v-if="false">
      <div class="demo-app-sidebar-section">
        <h2>All Appointments ({{ currentEvents.length }})</h2>
        <ul>
          <li v-for="event in currentEvents" :key="event.id">
            <small>
              {{
                formatCalendarDate(event.startStr, {
                  timeZone: "local",
                  day: "numeric",
                  month: "short",
                })
              }}
            </small>
            <b
              >{{
                formatCalendarDate(event.startStr, {
                  timeZone: "local",
                  hour: "numeric",
                  minute: "numeric",

                  time: "numeric",
                })
              }}
            </b>

            <i>{{ event.title }}</i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";

import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import firebase from "../../../firebaseConfig";
import { appointmentConverter } from "./Appointments/Appointments";
import { formatDate } from "@fullcalendar/vue";
import { eventBus } from "../eventbus";

export default {
  name: "Dashboard",
  components: {
    FullCalendar,
  },
  data: function () {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        allDaySlot: false,
        minTime: "06:30:00",
        maxTime: "24:00:00",
        duration: "00:15:00",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "timeGridWeek,timeGridDay",
        },
        initialView: "timeGridDay",
        //initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        eventSources: [
          {
            events: this.loadAppointmentsForAdmin,
            color: "#53ba47",
            textColor: "black",
          },
          // User created event source
          {
            events: this.loadAppointmentsForUser,
            color: "#1d509c",
            textColor: "white",
          },
        ],

        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        /* you can update a remote database when these fire:
            eventAdd:
            eventChange:
            eventRemove:
            */
      },
      currentEvents: [],
    };
  },

  methods: {
    loadAppointmentsForAdmin: function (
      info,
      successCallback,
      failureCallback
    ) {
      const isConfirmed = true;
      this.loadAppointments(
        info,
        successCallback,
        failureCallback,
        isConfirmed
      );
    },
    loadAppointmentsForUser: function (info, successCallback, failureCallback) {
      const isConfirmed = false;
      this.loadAppointments(
        info,
        successCallback,
        failureCallback,
        isConfirmed
      );
    },
    loadAppointments: function (
      info,
      successCallback,
      failureCallback,
      isConfirmed
    ) {
      //let start = moment(info.start.valueOf()).format("YYYY-MM-DD");
      //let end = moment(info.end.valueOf()).format("YYYY-MM-DD");
      if (firebase.auth().currentUser)
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is part of business.
            let customer = idTokenResult.claims.customer;
            if (customer) {
              let firestore = firebase.firestore();

              console.log("loggin appointments for:", customer);
              console.log("isConfirmed", isConfirmed);
              firestore
                .collection("appointments")
                .where("customerId", "==", customer)
                .where("isConfirmed", "==", isConfirmed)
                .withConverter(appointmentConverter)
                .get()
                .then(function (querySnapshot) {
                  var list = [];
                  querySnapshot.forEach(function (doc) {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());
                    let appointment = doc.data();
                    appointment.id = doc.id;
                    list.push(appointment);
                  });
                  console.log("list:", list);
                  successCallback(list);
                })
                .catch(function (error) {
                  console.log("Error getting documents: ", error);
                  failureCallback(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    formatCalendarDate: function (str, settings) {
      return formatDate(str, settings);
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
    },

    handleDateSelect(selectInfo) {
      //let title = prompt("Please enter a new title for your event");
      let calendarApi = selectInfo.view.calendar;

      calendarApi.unselect(); // clear date selection

      // if (title) {
      //   calendarApi.addEvent({
      //     id: createEventId(),
      //     title,
      //     start: selectInfo.startStr,
      //     end: selectInfo.endStr,
      //     allDay: selectInfo.allDay,
      //   });
      // }
    },

    handleEventClick(clickInfo) {
      // redirect to update appointment page
      let details = {
        id: clickInfo.event.id,
      };

      if (details.id) this.$router.push("/admin/appointment/" + details.id);

      eventBus.adminTabChanged("add", details);

      eventBus.selectAdminMenuOption("UpdateAppointment", details);
      // if (
      //   confirm(
      //     `Are you sure you want to delete the event '${clickInfo.event.title}'`
      //   )
      // ) {
      //   clickInfo.event.remove();
      // }
    },

    handleEvents(events) {
      this.currentEvents = events;
    },
  },
  created: function () {
    var self = this;

    //Redirect to login page if not authenticated
    if (firebase.auth().currentUser) {
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (idTokenResult.claims.admin) {
            // Show admin UI.
            // showAdminUI();
          } else {
            // Show regular user UI.
            // redirect to Login page
            self.$router.push("/login");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else self.$router.push("/login");
  },
  destroyed: function () {
    // unsubscribe form events
  },
};
</script>

<style lang='css'>
.fc {
  /* the calendar root */
  /* max-width: 1100px; */
  margin: 0 auto;
}

.fc-button-active {
  background-color: gray;
}
.demo-app {
  padding-top: 15px;
}
</style>
